import {
  Navigate,
  createBrowserRouter,
} from 'react-router';

import {
  Login,
  UseApp,
  SignUp,
  HTSSignUp,
  Handspring,
  SignInToApp,
  MasterLogin,
  HTSProfileSetup,
  ProfileSetup,
  ConfirmEmail,
  ResetPassword,
  ForgotPassword,
  LoginWithToken,
  PaymentRequired,
  SignUpWithPurchase,
  RedirectToDocument,
  SitePersonalization,
} from 'web-auth-containers';

import {
  SubscriptionPage,
} from 'web-containers';

import MainLayout from './MainLayout';
import RouterErrorBoundary from './RouterErrorBoundary';

import privateRoutes from './privateRoutes';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: privateRoutes,
    errorElement: <RouterErrorBoundary />,
  },
  {
    path: '/login',
    Component: Login,
  },
  {
    path: '/masterlogin',
    Component: MasterLogin,
  },
  {
    path: '/use_app',
    element: <UseApp />,
  },
  {
    path: '/get_app',
    element: <UseApp getApp />,
  },
  {
    path: '/sso',
    element: <SignInToApp />,
  },
  {
    path: '/forgot-password',
    Component: ForgotPassword,
  },
  {
    path: '/reset/:token',
    Component: ResetPassword,
  },
  {
    path: '/signup',
    Component: SignUp,
  },
  {
    path: '/profile_setup',
    Component: ProfileSetup,
  },
  {
    path: '/site_personalization',
    Component: SitePersonalization,
  },
  {
    path: '/payment_required',
    Component: PaymentRequired,
  },
  {
    path: '/accessToken',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/accessToken/:token',
    Component: LoginWithToken,
  },
  {
    path: '/confirm/:token',
    Component: ConfirmEmail,
  },
  {
    path: '/product/:slug',
    element: <SignUpWithPurchase />,
  },
  {
    path: '/product_plan/:slug',
    element: <SignUpWithPurchase isPlan />,
  },
  {
    path: '/test_product/:slug',
    element: <SignUpWithPurchase isTest />,
  },
  {
    path: '/test_product_plan/:slug',
    element: <SignUpWithPurchase isTest isPlan />,
  },
  {
    path: '/view_document/:id',
    Component: RedirectToDocument,
  },
  {
    path: '/hts',
    Component: HTSSignUp,
  },
  {
    path: '/hts-setup',
    Component: HTSProfileSetup,
  },
  {
    path: '/handspring',
    Component: Handspring,
  },
  {
    path: '/subscription',
    Component: SubscriptionPage,
  },
  {
    path: '/:slug',
    element: <SignUpWithPurchase requestWithSlug />,
  },
], {
  future: {
    v7_relativeSplatPath: true,
    v7_startTransition: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

export default router;
